<template>
  <div class="animated fadeIn" v-if="test_package_groups && parsed_groups">
    <basic-heading title="Sort Test Packages Groups" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <div>
      <b-alert show variant="info">
        <p>
          Test package group ordering dictates how test packages groups are
          ordered when displayed to customers.
        </p>
        <hr />
        <p class="mb-0">
          Test package ordering may be
          <a href="/#/testpackages/sort">updated here</a>.
        </p>
      </b-alert>
    </div>
    <b-card
      no-body
      v-for="(type, package_id) in test_package_groups"
      :key="package_id"
    >
      <b-card-header>
        <h5>{{ type.name }}</h5>
      </b-card-header>
      <b-card-body>
        <sortable-list
          v-if="type.groups && type.groups.length"
          :list="type.groups"
          :groupBy="`test_package_type_${package_id}`"
          keyField="id"
          labelField="name"
          @onOrderChange="onOrderChange"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import BasicHeading from "@/components/shared/BasicHeading";
import VueNotifications from "vue-notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testPackageNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import SortableList from "@/components/shared/SortableList";
import TestPackageGroupCollection from "@/collections/lab/TestPackageGroupCollection";

const LaboratoryRepository = LabRepositoryFactory.get("laboratory");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestPackageGroupSort",
  components: {
    SortableList,
    BasicHeading,
    HeaderButtonGroup,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-shovel",
            linkto: "/testpackages",
            title: "Test package list",
          },
          {
            icon: "fa-layer-group",
            linkto: "/testpackagegroups",
            title: "Test package group list",
          },
        ],
      };
    },
  },
  data() {
    return {
      group_coll: null,
      test_package_groups: null,
      parsed_groups: null,
    };
  },
  methods: {
    fetchTestPackageGroups() {
      let collection = new TestPackageGroupCollection();
      let filter = collection.getFilter();

      filter.sortAddAsc("position");
      filter.filterEquals(
        "laboratory_id",
        this.$store.getters.getLaboratoryContext.id
      );

      collection.fetch().then((response) => {
        if (response && response.getStatus() === 200) {
          this.group_coll = collection;
        }
      });
    },
    formatTestPackageGroups() {
      let groups = {};
      let parsed_groups = {};

      this.group_coll.models.forEach((group) => {
        let type_id = group.sample_type_id;

        if (type_id && group && group.id && group.sample_type) {
          if (!groups[type_id]) {
            groups[type_id] = { name: group.sample_type.name, groups: [] };
          }
          if (!parsed_groups[group.id]) {
            groups[type_id].groups.push(group);
            parsed_groups[group.id] = group;
          }
        }
      });

      this.test_package_groups = groups;
      this.parsed_groups = parsed_groups;
    },
    onOrderChange(sorted) {
      return new Promise((resolve, reject) => {
        LaboratoryRepository.sortTestPackageGroups(
          this.$store.getters.getLaboratoryContext.id,
          sorted
        )
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              resolve(true);
            } else {
              reject(false);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    this.fetchTestPackageGroups();
  },
  watch: {
    group_coll: {
      handler() {
        this.formatTestPackageGroups();
      },
      deep: true,
    },
  },
  notifications: testPackageNotifications,
};
</script>
